import styled from 'styled-components';

import { LiveEvent } from '@/pages/LiveEvent/store/liveEvent/types';
import { useLiveEventLocations } from '@/pages/LiveEvent/LiveEventLocationsContext';
import { LiveEventHighlightsBody } from '@/pages/LiveEvent/LiveEventHighlightsBody/LiveEventHighlightsBody';

type LiveEventHighlightsV2Props = Pick<LiveEvent, 'title' | 'id' | 'teaser'> & {
  parentJourneyId?: number;
};

const StyledCard = styled.div`
  border: 1px solid ${(p) => p.theme.colors.neutral.outline1};
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const DateContainer = styled.div`
  gap: 16px;
  display: flex;
  align-items: center;
`;

const DateBadge = styled.div`
  width: 68px;
  height: 68px;
  display: flex;
  padding: 16px;
  background: ${({ theme }) => theme.colors.secondary.container};
  align-items: center;
  border-radius: 8px;
  flex-direction: column;
`;

const DateTitle = styled.h4`
  ${({ theme }) => theme.typography.title4};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
`;

const CommonTitle = styled.h3`
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

export const LiveEventHighlights = ({ title, parentJourneyId, id, teaser }: LiveEventHighlightsV2Props): JSX.Element => {
  const { activeLocation } = useLiveEventLocations();

  return (
    <StyledCard>
      <DateContainer>
        <DateBadge>
          <DateTitle>{activeLocation?.monthName}</DateTitle>
          <CommonTitle>{activeLocation?.dayOfMonth}</CommonTitle>
        </DateBadge>
        <CommonTitle>{title}</CommonTitle>
      </DateContainer>
      <LiveEventHighlightsBody title={title} parentJourneyId={parentJourneyId} id={id} teaser={teaser} />
    </StyledCard>
  );
};
